<template>
    <div v-if="isLoaded">
        <!-- BEGIN: Header-->
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="sidebar-detached sidebar-left">
                <div class="sidebar">
                    <filter-component />
                </div>
            </div>
            <div class="side-bar content-detached content-right">
                <div class="content-body">
                    <authorized-user :card-data='cardData' :user='userStore.user'></authorized-user>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useAuthenticatedUserCheckoutStore } from '../../stores/AuthenticatedUserCheckoutStore.js'
import { useUserStore } from '../../stores/UserStore.js'
import {ref,reactive} from 'vue'
export default{
    name:'AuthorizedUsersComponent',
    setup(){
        const isLoaded = ref(false),
        cardData = reactive({});
        return{
            authenticatedUserCheckoutStore : useAuthenticatedUserCheckoutStore(),
            userStore:useUserStore(),
            isLoaded,
            cardData,
        }
    },
    watch: {
        'cardData'(value) {
            this.authenticatedUserCheckoutStore.cards = value
        },
    },
    mounted(){
        let $this = this;
        if (document.readyState === "complete") {
            setTimeout(() => {
                this.$nextTick(() => {
                        $this.getCardData();
                });
            }, 2000);
        } else {
            window.addEventListener("load", () => {
                setTimeout(() => {
                    this.$nextTick(() => {
                        $this.getCardData();
                    });
                }, 2000);
            });
        }
    },
    methods: {
        getCardData(){
            const route = this.$router.resolve(
                {
                    name: 'authorized-user',
                }
            );
            axios.get(route.href)
            .then(response => {
                if(response.data.error == false) {
                    // toastr.error(response.data.message, 'Error!');
                    this.isLoaded = true
                    this.cardData = response.data.data.cardData
                    return;
                }
            })
            .catch(function (error) {
                toastr.error(error.message, 'Error!');
            });
        }
    },
}
</script>
